import { Languages } from "src/common/descriptions/types";
import { ServiceContractsDescriptions } from "./types";

const DescriptionsEnUs: ServiceContractsDescriptions = {
    TITLE: "Service Contracts",
    TABLE: {
        ACTION_BUTTON: "Create Service Contract",
        SEARCH_PLACEHOLDER: "Search Service Contract",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        CUSTOMER: "Customer",
        TOTAL: "Total",
        NEXT_SERVICE_DEBIT: "Next Debit",
        STATUS: "Status",
        ACTIONS: "Action",
        IS_MONTHLY: "Is Monthly",
        PAY_DATE: "Pay Date",
        DESCRIPTION: "Description",
        SERVICE_CATEGORY: "Service Category",
        START_DATE: "Start Date",
        CREATED_AT: "Created At",
    },
    MAIN_ACTION_TITLE: "Getting information",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    ACCEPT: "Accept",
    BACK: "Back",
    VIEW_ACTIVES: "View actives",
    VIEW_INACTIVES: "View inactives",
    DATA: {
        TITLE: "Service Contract Detail",
        TAB_DETAIL: "Detail",
        TAB_ACTIVITY_LOG: "Activity Log",
        TAB_SERVICE_CONTRACT_DEBITS: "Service Contract Debits",
        TAB_SERVICE_CONTRACT_PAYMENTS: "Service Contract Payments",
    },
}

const DescriptionsEsUs: ServiceContractsDescriptions = {
    TITLE: "Contratos Activos",
    TABLE: {
        ACTION_BUTTON: "Crear Contrato",
        SEARCH_PLACEHOLDER: "Buscar Contrato",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        CUSTOMER: "Cliente",
        TOTAL: "Total",
        NEXT_SERVICE_DEBIT: "Siguiente Débito",
        STATUS: "Estado",
        ACTIONS: "Acciones",
        IS_MONTHLY: "Es Mensual",
        PAY_DATE: "Día de Pago",
        DESCRIPTION: "Descripción",
        SERVICE_CATEGORY: "Categoría de Servicio",
        START_DATE: "Fecha Inicio",
        CREATED_AT: "Creado",
    },
    MAIN_ACTION_TITLE: "Obteniendo información",
    MAIN_ACTION_DESCRIPTION: "Por favor espera...",
    ACCEPT: "Aceptar",
    BACK: "Regresar",
    VIEW_ACTIVES: "Ver activos",
    VIEW_INACTIVES: "Ver inactivos",
    DATA: {
        TITLE: "Detalle Contrato de Servicio",
        TAB_DETAIL: "Detalle",
        TAB_ACTIVITY_LOG: "Registro de actividad",
        TAB_SERVICE_CONTRACT_DEBITS: "Débitos de Contrato de Servicio",
        TAB_SERVICE_CONTRACT_PAYMENTS: "Pagos de Contrato de Servicio",
    },
}

export const serviceContractsDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}
